import {
  SET_STOCKS,
  SET_STOCKS_DATA_LOADING,
  GET_SEARCH_PRODUCTS,
  SET_SEARCH_PRODUCTS_DATA_LOADING,
  GET_SEARCH_SUPPLIERS,
  SET_SEARCH_SUPPLIERS_DATA_LOADING,
  SET_SEARCH_STOCK_BY_ID,
  SET_SEARCH_CATEGORIES_DATA_LOADING,
  GET_SEARCH_CATEGORIES
} from '../actions/types';

const initialState = {
  isLoading: false,
  stocksData: [],
  totalRecords: 0,
  currentPage: 0,
  rowsPerPage: 10,
  suggestProducts: [],
  isSuggestedProductsLoading: false,
  suggestSuppliers: [],
  isSuggestedSuppliersLoading: false,
  searchedStockById: [],
  suggestCategories: [],
  isSuggestedCategoriesLoading: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_STOCKS_DATA_LOADING:
      return {
        ...state,
        isLoading: payload !== false,
      };
    case SET_STOCKS: {
      const isSearchPayload =
        payload &&
        typeof payload === 'object' &&
        !Array.isArray(payload) &&
        'data' in payload;
      const data = isSearchPayload ? payload.data : payload;
      const totalRowCount = isSearchPayload ? payload.totalRowCount : undefined;
      const totalRecords =
        Array.isArray(totalRowCount) && totalRowCount.length > 0
          ? (totalRowCount[0]?.total_stocks ?? 0)
          : typeof totalRowCount === 'number'
            ? totalRowCount
            : Array.isArray(totalRowCount) && totalRowCount.length === 0
              ? 0
              : state.totalRecords;
      return {
        ...state,
        stocksData: Array.isArray(data) ? data : [],
        totalRecords: isSearchPayload ? totalRecords : (Array.isArray(data) ? data.length : 0),
        currentPage: isSearchPayload && typeof payload.page === 'number' ? payload.page : 0,
        rowsPerPage: isSearchPayload && typeof payload.rowsPerPage === 'number' ? payload.rowsPerPage : 10,
        isLoading: false,
      };
    }

    case GET_SEARCH_PRODUCTS:
      console.log(payload);
      return {
        ...state,
        suggestProducts: payload,
        isSuggestedProductsLoading: false,
      };

    case SET_SEARCH_PRODUCTS_DATA_LOADING:
      return {
        ...state,
        isSuggestedProductsLoading: true,
      };

    case GET_SEARCH_SUPPLIERS:
      return {
        ...state,
        suggestSuppliers: payload,
        isSuggestedSuppliersLoading: false,
      };

    case SET_SEARCH_SUPPLIERS_DATA_LOADING:
      return {
        ...state,
        isSuggestedSuppliersLoading: true,
      };

    case SET_SEARCH_STOCK_BY_ID:
      return {
        ...state,
        searchedStockById: payload,
      };

      case GET_SEARCH_CATEGORIES:
        return {
          ...state,
          suggestCategories: payload,
          isSuggestedCategoriesLoading: false,
        };
  
      case SET_SEARCH_CATEGORIES_DATA_LOADING:
        return {
          ...state,
          isSuggestedCategoriesLoading: true,
        };

    default:
      return state;
  }
}
